import React from "react";
import "../../css/SuccessScreen.css";

const SuccessScreen = () => {
  const handleBackClick = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    window.location.href = `${baseUrl}`
  };
  return (
    <div className="success-container">
      <div className="success-content">
        <div style={{padding: '20px'}}>
        <h2>Rejestracja przebiegła pomyślnie!</h2>
        <p>W ciągu kilku minut na podany adres e-mail wyślemy wiadomość z potwierdzeniem i dalszymi informacjami.</p>
        <p>Do zobaczenia na szlaku! 🏔️🏳️‍🌈☀️</p>
        <button className="registration-success-button" onClick={handleBackClick}>
            Powrót do listy wycieczek
          </button>
      </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
